export const OFFER_HEADER_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferHeaderUpdated";
export const OFFER_TYPE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferTypeChanged";
